import { type ReactNode, useId } from 'react'

import styles from './CollapsibleSection.module.scss'

import { c } from '@/utils'

interface CollapsibleSectionProps {
  label: string
  description?: string
  summary: string
  expanded: boolean
  onToggle: () => void
  children: ReactNode
}

const CollapsibleSection = ({ label, description, summary, expanded, onToggle, children }: CollapsibleSectionProps) => {
  const contentId = useId()
  const descriptionId = useId()

  return (
    <div className={styles.collapsibleSection}>
      <button
        type="button"
        className={styles.collapsibleHeader}
        onClick={onToggle}
        aria-expanded={expanded}
        aria-controls={contentId}
        aria-describedby={description ? descriptionId : undefined}
      >
        <div className={styles.collapsibleHeaderLeft}>
          <span className={c(styles.collapsibleChevron, expanded && styles.expanded)} aria-hidden="true">
            &#9654;
          </span>
          <span className={styles.collapsibleLabel}>{label}</span>
          <span className={styles.collapsibleSummary} aria-live="polite" aria-atomic="true">
            {summary}
          </span>
        </div>
      </button>
      {description && (
        <div id={descriptionId} className={styles.collapsibleDescription}>
          {description}
        </div>
      )}

      <div id={contentId} className={styles.collapsibleBody} hidden={!expanded}>
        {children}
      </div>
    </div>
  )
}

export default CollapsibleSection
